import { TourProvider } from "@egovernments/digit-ui-react-components";
import React from "react";
import { useMatch } from "react-router-dom";
import EmployeeApp from "./pages/employee";
import { CustomisedHooks } from "./hooks";
import { UICustomizations } from "./configs/UICustomizations";
import HRMSCard from "./components/HRMSCard";
import WorkbenchCard from "./components/WorkbenchCard";
import DigitJSONForm from "./components/DigitJSONForm";
import LevelCards from "./components/LevelCards";
import { Loader } from "@egovernments/digit-ui-components";

import * as parsingUtils from "../src/utils/ParsingUtils"
import CustomSwitch from "./components/CustomSwitch";

const WorkbenchModule = ({ stateCode, userType, tenants }) => {
  const moduleCode = ["workbench","mdms","schema","hcm-admin-schemas"];
  const match = useMatch("/employee/workbench/*");
  const path = match?.pathnameBase || "";
  const language = Digit.StoreData.getCurrentLanguage();
  const modulePrefix = window?.globalConfigs?.getConfig("CORE_UI_MODULE_LOCALE_PREFIX") || "rainmaker";

  const { isLoading, data: store } = Digit.Services.useStore({
    stateCode,
    moduleCode,
    language,
    modulePrefix
  });
  if (isLoading) {
    return  <Loader page={true} variant={"PageLoader"} />;
  }

  return <TourProvider>
    <EmployeeApp path={path} stateCode={stateCode} />
  </TourProvider>
};

const componentsToRegister = {
  WorkbenchModule,
  WorkbenchCard,
  DigitJSONForm,
  LevelCards,
  DSSCard: null, // TO HIDE THE DSS CARD IN HOME SCREEN as per workbench
  HRMSCard ,// Overridden the HRMS card as per workbench
  CustomSwitch
};

const overrideHooks = () => {
  Object.keys(CustomisedHooks).map((ele) => {
    if (ele === "Hooks") {
      Object.keys(CustomisedHooks[ele]).map((hook) => {
        Object.keys(CustomisedHooks[ele][hook]).map((method) => {
          setupHooks(hook, method, CustomisedHooks[ele][hook][method]);
        });
      });
    } else if (ele === "Utils") {
      Object.keys(CustomisedHooks[ele]).map((hook) => {
        Object.keys(CustomisedHooks[ele][hook]).map((method) => {
          setupHooks(hook, method, CustomisedHooks[ele][hook][method], false);
        });
      });
    } else {
      Object.keys(CustomisedHooks[ele]).map((method) => {
        setupLibraries(ele, method, CustomisedHooks[ele][method]);
      });
    }
  });
};

/* To Overide any existing hook we need to use similar method */
const setupHooks = (HookName, HookFunction, method, isHook = true) => {
  window.Digit = window.Digit || {};
  window.Digit[isHook ? "Hooks" : "Utils"] = window.Digit[isHook ? "Hooks" : "Utils"] || {};
  window.Digit[isHook ? "Hooks" : "Utils"][HookName] = window.Digit[isHook ? "Hooks" : "Utils"][HookName] || {};
  window.Digit[isHook ? "Hooks" : "Utils"][HookName][HookFunction] = method;
};
/* To Overide any existing libraries  we need to use similar method */
const setupLibraries = (Library, service, method) => {
  window.Digit = window.Digit || {};
  window.Digit[Library] = window.Digit[Library] || {};
  window.Digit[Library][service] = method;
};

/* To Overide any existing config/middlewares  we need to use similar method */
const updateCustomConfigs = () => {
  setupLibraries("Customizations", "commonUiConfig", { ...window?.Digit?.Customizations?.commonUiConfig, ...UICustomizations });
  setupLibraries("Utils","parsingUtils",{...window?.Digit?.Utils?.parsingUtils,...parsingUtils})
};


 const initWorkbenchComponents = () => {
  overrideHooks();
  updateCustomConfigs();
  Object.entries(componentsToRegister).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};

export {initWorkbenchComponents, DigitJSONForm};

